/**
 * Created by baladewa on 5/20/16.
 */
'use strict';
(function () {
    angular
        .module('commons')
        .component('pairingComponent', {
            templateUrl: 'create-pairing/components/pairing-component.tpl.html',
            controller: function (EventManagerService, CreatePairing, $timeout) {

                var vm = this;
                vm.rowBlock=[];
                vm.filteredData = [];
                vm.displayPairing = false;
                vm.fixedTopHeader = false;
                vm.selectedDate = "";

                var min_screen_width = 1200;
                vm.screen_left_panel = 100;
                vm.screen_right_panel = 0;
                vm.comHeight = window.innerHeight - (70 + 42 + 40 + 80);
                vm.toolTipModel = {
                    origin:null,
                    destination:null,
                    departureTime:null,
                    arrivalTime:null,
                    flightNumber:null,
                    avaliableCaptian:null,
                    avaliableCabinCrew:null,
                    avaliableCabinSupervisor:null,
                    avaliableFirstOfficer:null,
                    availableSecondOfficer:null,
                    requiredCaptain: null,
                    requiredFirstOfficer: null,
                    requiredSecondOfficer: null,
                    requiredCabinSupervisor: null,
                    requiredCabinCrew: null,
                    filteredCrewTypes: null
                };
                vm.isElasticLoadingVisible = false;
                vm.displayParams = {
                    no_of_actual_hour_cols_per_day : 24,
                    no_of_actual_day_cols_per_week: 7,
                    no_actual_day_cols_per_month : 30,
                    no_of_hour_cols_per_day : 26,
                    no_day_cols_per_week : 7,
                    no_day_cols_per_month : 32,
                    no_week_cols_per_month : 4
                };

                vm.timeLineData = [];
                vm.dayLineData = [];

                vm.minimum_number_of_columns = vm.displayParams.no_of_hour_cols_per_day;
                vm.actual_number_of_coulmns = 0;
                if (vm.viewMode == 'W') {
                    vm.minimum_number_of_columns = vm.displayParams.no_day_cols_per_week;
                }
                if (vm.viewMode == 'M') {
                    vm.minimum_number_of_columns = vm.displayParams.no_day_cols_per_month;
                }

                vm.actual_screen_width = window.innerWidth;

                if (!!vm.actual_screen_width && vm.actual_screen_width > min_screen_width) {
                    vm.screen_right_panel = vm.actual_screen_width - vm.screen_left_panel;
                }

                vm.scrollAreaWidth = vm.actual_screen_width;

                vm.moveOnBlock = function(e, flObj){
                    var findPosition = function(){
                        var H = 'left',V='top';
                        if((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel){
                            H = 'left';
                        }else{
                            H = 'right';
                        }
                        if((e.clientY + e.target.offsetHeight + 100) > vm.comHeight){
                            V = 'bottom';
                        }else{
                            V = 'top';
                        }
                        return H + '-' + V;
                    };

                    var crewTypeCodes = function() {
                        var crewTypes = CreatePairing.searcParamStore.flightSearch.crewTypeCodes.map(function(type) { return type.crewTypeCode; });
                        var showAll = crewTypes.length === 0
                        return {
                            cp: showAll || crewTypes.includes("CP"),
                            fo: showAll || crewTypes.includes("FO"),
                            so: (showAll || crewTypes.includes("SO")) && flObj.requiredSecondOfficer !== 0,
                            cs: showAll || crewTypes.includes("CS"),
                            cc: showAll || crewTypes.includes("CC"),
                        }
                    };

                    vm.toolTipModel = {
                        placement:findPosition(),
                        origin:flObj.origin,
                        destination:flObj.destination,
                        departureTime:flObj.estimatedDepartureTime,
                        arrivalTime:flObj.estimatedArrivalTime,
                        flightNumber:flObj.flightNumber,
                        avaliableCaptian:flObj.avaliableCaptian,
                        avaliableCabinCrew:flObj.avaliableCabinCrew,
                        avaliableCabinSupervisor:flObj.avaliableCabinSupervisor,
                        avaliableFirstOfficer:flObj.avaliableFirstOfficer,
                        availableSecondOfficer: flObj.availableSecondOfficer,
                        requiredCaptain: flObj.requiredCaptain,
                        requiredFirstOfficer: flObj.requiredFirstOfficer,
                        requiredSecondOfficer: flObj.requiredSecondOfficer,
                        requiredCabinSupervisor: flObj.requiredCabinSupervisor,
                        requiredCabinCrew: flObj.requiredCabinCrew,
                        filteredCrewTypes: crewTypeCodes()
                    };
                };

                vm.dblOnBlock = function(e, flObj){
                    var option = {
                        selectedBlock:flObj
                    };
                    vm.dblClickOnBlock(option);
                };

                vm.clickOnBlock = function(flObj){
                    vm.selectedDate = moment(flObj.estimatedDepartureDate, vm.dateFormat).format(vm.dateFormat);
                };

                EventManagerService.registerEventListener(EventManagerService.EVENT.SHOW_HIDE_LOADING, showHideElasticLoading);

                EventManagerService.registerEventListener(EventManagerService.EVENT.CREATE_PAIRING.VIEW_CHANGE, function(data){
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                    $timeout(function () {
                        vm.viewMode = data;
                        vm.timeLineData = [];
                        vm.dayLineData = [];
                        vm.minimum_number_of_columns = vm.displayParams.no_of_hour_cols_per_day;
                        vm.actual_number_of_coulmns = 0;
                        if (vm.viewMode == 'W') {
                            vm.minimum_number_of_columns = vm.displayParams.no_day_cols_per_week;
                        }
                        if (vm.viewMode == 'M') {
                            vm.minimum_number_of_columns = vm.displayParams.no_day_cols_per_month;
                        }
                        renderTimeLine();
                    }, 0);
                });

                EventManagerService.registerEventListener(EventManagerService.EVENT.CREATE_PAIRING.FLIGHT_DATA_CHANGE, function(){
                    filterData();
                    scrollSettings();
                });

                EventManagerService.registerEventListener(EventManagerService.EVENT.CREATE_PAIRING.APPEND_FLIGHT_DATA, filterAppendData);

                function scrollSettings(){
                    var temp = vm.selectedDate==''?vm.fromDate: vm.selectedDate;
                    $(".right-section").animate({scrollLeft: getTimeInMinFromStartDate(temp, '00:00')}, "slow");
                }

                function getTimeInMinFromStartDate(checkInDate, checkInTime) {
                    var mo_checkIn = moment(checkInDate + ' ' + checkInTime, 'DD/MM/YYYY HH:mm');
                    var diffFromStart = mo_checkIn.diff(vm.mo_start, 'm');
                    return Math.round(diffFromStart * vm.minuteToPixelRatio);
                }

                function setUsedInPatternWidth(){
                    return vm.viewMode == 'M'?1:3;
                }

                function showHideElasticLoading(data){
                    if (data.target == 'createPairingFlights') {
                        vm.isElasticLoadingVisible = data.flag;
                    }
                }

                function filterData(){
                    vm.filteredData = {};
                    var temp = CreatePairing.getPairingFlightData();
                    if(temp!==null){
                        var tempData = [];
                        var openFlightsFontColor =  _.findWhere(CreatePairing.getColorCode(),{trackingCode: "NOT_USED_FLIGHTS_FOR_PAIRINGS"}).fontColor;
                        angular.forEach(temp, function(FlData){
                            FlData.leftPos = getTimeInMinFromStartDate(FlData.estimatedDepartureDate, FlData.estimatedDepartureTime);
                            FlData.width = getTimeInMinFromStartDate(FlData.estimatedArrivalDate, FlData.estimatedArrivalTime) - getTimeInMinFromStartDate(FlData.estimatedDepartureDate, FlData.estimatedDepartureTime);
                            FlData.border = !FlData.usedInPattern?setUsedInPatternWidth:0;
                            if(FlData.usedInPattern)
                            FlData.border = FlData.partiallyAssignedPattern?setUsedInPatternWidth():0;
                            FlData.borderColour = FlData.partiallyAssignedPattern?'0px solid #FFA500':'0px solid #FF0000';
                            FlData.fontColor = !FlData.usedInPattern?openFlightsFontColor:FlData.fontColor;
                            //FlData.backGround = FlData.usedInCurrentPattern?"19b03d":"1976D2";

                            tempData.push(FlData);
                        });

                        if (tempData.length > 0){
                            $timeout(function(){
                                vm.tempFilteredData = _.groupBy(tempData, 'modelNo');
                                Object.keys(vm.tempFilteredData).forEach(function(key) {
                                    // vm.tempFilteredData[key].sort(function(obj1, obj2){
                                    //     return getDiffOfTimeWithDates(obj1)-getDiffOfTimeWithDates(obj2);
                                    // })
                                	var flightRowData = {};
                                	angular.forEach(vm.tempFilteredData[key], function(flight) {
                            			formatFilteredRow(flight, flightRowData, key);
                                	});
                                	Object.assign(vm.filteredData, flightRowData);
                                })
                                vm.displayPairing = true;
                                CreatePairing.setFlightFilteredData(vm.filteredData);
                                EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.VIEWPORT_DATA_CHANGE);
                            },0);
                        }
                    }else{
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.VIEWPORT_DATA_CHANGE);
                    }
                };

                function formatFilteredRow(newflight, flightRowData, key) {
                	var isFlightAdded = false;
                	if(Object.keys(flightRowData).length === 0 && flightRowData.constructor === Object
){
            			flightRowData[key + "-" +newflight.flightLegId] = [];
            			flightRowData[key + "-" +newflight.flightLegId].push(newflight);
            			return;
            		}
                	Object.keys(flightRowData).forEach(function(key) {
                		var count = 0;
                		if(!isFlightAdded) {
                			// angular.forEach(flightRowData[key], function(existingFlight) {
                      var existingFlight = flightRowData[key][flightRowData[key].length -1];
                    			if(isFlightTimingsAreCollided(existingFlight, newflight)) {
                    				count++;
                    			}else if(existingFlight.destination == newflight.origin){
                            // });
                            // if(count == flightRowData[key].length) {
                            flightRowData[key].push(newflight);
                            isFlightAdded = true;
                            // }
                          }
                		}
                	});
                	//If flight is not added in first feasible row.Creating one more row so that collision can't happen.
                	if(!isFlightAdded) {
                		newflight.dummyRow = true;
                		var index = key + "-" +newflight.flightLegId;
                		flightRowData[index] = [];
                		flightRowData[index].push(newflight);
                	}
                }




                function isFlightTimingsAreCollided(existingFlight, newflight) {
                	var existingFlightArrivalDate = moment(existingFlight.estimatedArrivalDate + "" +existingFlight.estimatedArrivalTime,"DD/MM/YYYY HH:mm");
        			var existingFlightDepDate = moment(existingFlight.estimatedDepartureDate + "" +existingFlight.estimatedDepartureTime,"DD/MM/YYYY HH:mm");

        			var newFlightArrivalDate = moment(newflight.estimatedArrivalDate + "" +newflight.estimatedArrivalTime,"DD/MM/YYYY HH:mm");
        			var newFlightDepDate = moment(newflight.estimatedDepartureDate + "" +newflight.estimatedDepartureTime,"DD/MM/YYYY HH:mm");

        			if(existingFlightArrivalDate >= newFlightDepDate ){
        			  return true;
              }else {
        			  return false;
              }
        			// if(getDiffOfTimeWithDates(existingFlight) > getDiffOfTimeWithDates(newflight)) {
        			// 	return (!newFlightArrivalDate.isBetween(existingFlightDepDate, existingFlightArrivalDate))
						// && (!newFlightDepDate.isBetween(existingFlightDepDate, existingFlightArrivalDate));
        			// } else {
        			// 	return (!existingFlightArrivalDate.isBetween(newFlightDepDate, newFlightArrivalDate))
						// && (!existingFlightDepDate.isBetween(newFlightDepDate, newFlightArrivalDate));
        			// }
        		};

        		function getDiffOfTimeWithDates(obj1) {
        			var fromDate = moment(obj1.estimatedArrivalDate + "" +obj1.estimatedArrivalTime,"DD/MM/YYYY HH:mm");
        			var toDate = moment(obj1.estimatedDepartureDate + "" +obj1.estimatedDepartureTime,"DD/MM/YYYY HH:mm");
        			var duration = moment.duration(fromDate.diff(toDate));
        			return duration.asHours();
        		}

                function filterAppendData(appendedData){
                    var temp = appendedData;
                    if(temp.length!==0){
                        var tempData = [];
                        angular.forEach(temp, function(FlData){
                            FlData.leftPos = getTimeInMinFromStartDate(FlData.estimatedDepartureDate, FlData.estimatedDepartureTime);
                            FlData.width = getTimeInMinFromStartDate(FlData.estimatedArrivalDate, FlData.estimatedArrivalTime) - getTimeInMinFromStartDate(FlData.estimatedDepartureDate, FlData.estimatedDepartureTime);
                            FlData.border = !FlData.usedInPattern?setUsedInPatternWidth:0;
                            //FlData.backGround = FlData.usedInCurrentPattern?"19b03d":"1976D2";
                            tempData.push(FlData);
                        });

                        if (tempData.length > 0){
                            $timeout(function(){
                            	 vm.tempFilteredData = _.groupBy(tempData, 'modelNo');
                                 Object.keys(vm.tempFilteredData).forEach(function(key) {
                                 	vm.tempFilteredData[key].sort(function(obj1, obj2){
                                         return getDiffOfTimeWithDates(obj1)-getDiffOfTimeWithDates(obj2);
                                     })
                                 	var flightRowData = {};
                                 	angular.forEach(vm.tempFilteredData[key], function(flight) {
                             			formatFilteredRow(flight, flightRowData, key);
                                 	});
                                 	Object.assign(vm.filteredData, flightRowData);
                                 	CreatePairing.setFlightFilteredData(vm.filteredData);
                                 })

                                /*angular.forEach(vm.tempFilteredData, function(obj, objKey){
                                    vm.filteredData[objKey] = obj;
                                    CreatePairing.setFlightFilteredData(vm.filteredData);
                                });*/
                            },0);
                        }

                        var tempServiceData = CreatePairing.getPairingFlightData();
                        angular.forEach(temp, function(FlData){
                            tempServiceData.push(FlData);
                        });

                    }
                };

                function renderTimeLine() {
                    vm.timeLineData.length = 0;
                    vm.dayLineData.length = 0;
                    vm.scrollAreaWidth = 0;
                    console.log(vm.screen_right_panel +" , " +vm.minimum_number_of_columns +" , "+ window.innerWidth );
                    vm.columnWidthInPx = Math.floor((vm.screen_right_panel ) / vm.minimum_number_of_columns-3);
                    vm.minuteToPixelRatio = vm.columnWidthInPx / (60 * (vm.viewMode==='D'?1:24));
                    var col_start = moment(vm.fromDate, vm.dateFormat);
                    vm.mo_start = col_start;

                    var columnGapBy = 'd';
                    if (vm.viewMode == 'D') {
                        columnGapBy = 'h';
                    }
                    vm.actual_number_of_coulmns = 0;

                    //find the actual no of columns

                    var columnCount = 0,displayFormat = "";

                    if(vm.viewMode == 'D'){
                      vm.actual_number_of_coulmns = vm.displayParams.no_of_actual_hour_cols_per_day * vm.noOfDays.days;
                      columnCount = vm.displayParams.no_of_actual_hour_cols_per_day;
                      displayFormat = "HH:mm";
                    }

                    if (vm.noOfDays-1===0){//1 day data
                        if (vm.viewMode == 'D'){
                            vm.actual_number_of_coulmns = (vm.noOfDays===0?1:vm.noOfDays) * vm.minimum_number_of_columns;
                            columnCount = vm.displayParams.no_actual_day_cols_per_month;
                            displayFormat = "HH:mm";
                        }
                        if (vm.viewMode == 'W'){
                            vm.actual_number_of_coulmns = (vm.noOfDays===0?1:vm.noOfDays) * vm.minimum_number_of_columns;
                            columnCount = 1;
                            displayFormat = "ddd";
                        }
                        if (vm.viewMode == 'M'){
                            vm.actual_number_of_coulmns = (vm.noOfDays===0?1:vm.noOfDays) * vm.minimum_number_of_columns;
                            columnCount = vm.displayParams.no_of_actual_day_cols_per_week;
                            displayFormat = "ddd";
                        }

                    }else if(vm.noOfDays-1===6){//7 days data
                        if (vm.viewMode == 'D'){
                            vm.actual_number_of_coulmns = vm.displayParams.no_of_actual_hour_cols_per_day * vm.noOfDays;
                            columnCount = vm.displayParams.no_of_actual_hour_cols_per_day;
                            displayFormat = "HH:mm";
                        }
                        if (vm.viewMode == 'W'){
                            vm.actual_number_of_coulmns = vm.minimum_number_of_columns;
                            columnCount = 1;
                            displayFormat = "ddd";
                        }
                        if (vm.viewMode == 'M'){
                            vm.actual_number_of_coulmns = vm.displayParams.no_day_cols_per_month;
                            columnCount = vm.displayParams.no_of_actual_day_cols_per_week;
                            displayFormat = "ddd";
                        }
                    }else if(vm.noOfDays-1===29){//30 days data
                        if (vm.viewMode == 'D'){
                            vm.actual_number_of_coulmns = vm.minimum_number_of_columns * vm.noOfDays;
                            columnCount = vm.displayParams.no_day_cols_per_month;
                            displayFormat = "HH:mm";
                        }
                        if (vm.viewMode == 'W'){
                            vm.actual_number_of_coulmns = vm.displayParams.no_day_cols_per_month;
                            columnCount = 1;
                            displayFormat = "ddd";
                        }
                        if (vm.viewMode == 'M'){
                            vm.actual_number_of_coulmns = vm.displayParams.no_day_cols_per_month;
                            columnCount = vm.displayParams.no_of_actual_day_cols_per_week;
                            displayFormat = "ddd";
                        }
                    };

                    var tmp;
                    for (var i = 0; i < vm.actual_number_of_coulmns; i++) {
                        col_start = moment(col_start).startOf('day');
                        tmp = moment(col_start).add(i, columnGapBy);
                        vm.timeLineData.push({
                            headerLabel:tmp.format(displayFormat),
                            dayOfWeekShort: tmp.format('DDD'),
                            date: tmp.format('DD/MM/YYYY'),
                            dateShort : tmp.format('DD/MM')
                        });
                        vm.scrollAreaWidth += vm.columnWidthInPx + 2;


                        if( i % columnCount === 0 ){
                            vm.dayLineData.push({
                                dayLabelWidth: vm.columnWidthInPx * columnCount,
                                dayLabel: tmp.format('DD/MM/YYYY'),
                                dayOfWeekShort: tmp.format('ddd')
                            });
                        }
                    }
                    vm.scrollAreaWidth += vm.screen_left_panel;
                    filterData();
                    scrollSettings();
                }
            },
            bindings: {
                fromDate:'=',
                noOfDays:'<',
                dateFormat: '@',
                dblClickOnBlock:'&',
                goToDate:'&'
            }
        })
})();
